import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/flowLine',
  title: window.language['flow.lineStatistics'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Flow/FlowLine/index.js